import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { DocumentTitle } from 'src/routes/components';

import { AuthSplitLayout } from 'src/layouts/auth-split';
import LayoutAuth0 from 'src/pages/auth/auth0/layout-auth0';

import { Logo } from 'src/components/logo';
import { SplashScreen } from 'src/components/loading-screen';

import { AuthGuard , GuestGuard } from 'src/auth/guard';



// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  SignUpPage: lazy(() => import('src/pages/auth/jwt/sign-up')),
};

const authJwt = {
  path: 'jwt',
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: 'Hi, Welcome back' },
            }}
          >
            <Jwt.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'sign-up',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Jwt.SignUpPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
  ],
};

const Auth0 = {
  SignInPage: lazy(() => import('src/pages/auth/auth0/sign-in')),
  CallbackPage: lazy(() => import('src/pages/auth/auth0/callback')),
  LayoutAuth0: lazy(() => import('src/pages/auth/auth0/layout-auth0')),
  EmailVerifyPage: lazy(() => import('src/auth/view/auth0/emailVerifyView')),
  OnBoardingPage: lazy(() => import('src/auth/view/auth0/onBoardingView')),
};
const AcceptInvitationPage = lazy(() => import('src/pages/organization/subtabs/invitations/organisms/accept-invitation'));

const authAuth0 = [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout slotProps={{
            header: {
              slots: {
                leftArea: undefined,
                rightArea: undefined,
                topArea: undefined,
                bottomArea: undefined,
                centerArea: <Logo isSingle={false} />,
              }
            }
          }}>
            <Auth0.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'callback',
      element: (
        <AuthGuard>
          <>
            <DocumentTitle />
            <Auth0.CallbackPage />
          </>
        </AuthGuard>
      ),
    },
    {
      path: 'verify-email',
      element: (
        <LayoutAuth0>
          <Auth0.EmailVerifyPage />
        </LayoutAuth0>
      ),
    },
    {
      path: 'onboarding',
      element: (
        <LayoutAuth0>
          <Auth0.OnBoardingPage />
        </LayoutAuth0>
      ),
    },
  ]

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [...authAuth0],
  },
  {
    path: 'accept-invitation',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <AuthSplitLayout slotProps={{
          header: {
            slots: {
              leftArea: undefined,
              rightArea: undefined,
              topArea: undefined,
              bottomArea: undefined,
              centerArea: <Logo isSingle={false} />,
            }
          }
        }}
        sx={
          {
            backgroundImage: (theme) => (theme.palette as any).backgroundImage,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }
        }>
          <AcceptInvitationPage />
        </AuthSplitLayout>
      }
    ]
  }
];
